// composables/useToast.js
import { ref } from 'vue'

export const toast = ref({
  message: '',
  type: 'success', // success | warning | danger
  visible: false
})

export function useToast() {
  const showToast = (message, type = 'success', duration = 5000) => {
    toast.value = { message, type, visible: true }

    setTimeout(() => {
      toast.value.visible = false
    }, duration)
  }

  return { toast, showToast }
}
